
export const data = [
    { 
        title: 'Transport',
        options: [
            { title: 'Train' },
            { title: 'Bus' },
            { title: 'Roads' },
        ]
    },
    { 
        title: 'Amenities',
        options: [
            { title: 'Sports & Recreation' },
            { title: 'Shopping' },
            { title: 'Entertainment & Culture' },
            { title: 'Education' },
            { title: 'Employment' },

        ]
    }
];